import { useState, useEffect, useRef } from 'react';
import { MessageCircle, Phone, FileText, Headphones, X } from 'lucide-react';

const FloatingContactMenu = ({ onOpenChat, onOpenQuote, onOpenConsultation, onOpenCallback }) => {
  const [open, setOpen] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (open && menuRef.current && !menuRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [open]);

  const items = [
    { icon: MessageCircle, label: 'Chat', action: onOpenChat, color: 'bg-gold text-navy' },
    { icon: FileText, label: 'Instant Quote', action: onOpenQuote, color: 'bg-navy text-white' },
    { icon: Phone, label: "We'll Call You", action: onOpenCallback, color: 'bg-green-600 text-white' },
    { icon: Headphones, label: 'Consultation', action: onOpenConsultation, color: 'bg-purple-600 text-white' },
  ];

  return (
    <div ref={menuRef} className="fixed bottom-6 right-6 z-50 md:hidden" data-testid="floating-contact-menu">
      {/* Expanded menu items */}
      {open && (
        <div className="absolute bottom-16 right-0 flex flex-col gap-3 mb-2 animate-in fade-in slide-in-from-bottom-4 duration-200">
          {items.map((item) => (
            <button
              key={item.label}
              data-testid={`fab-${item.label.toLowerCase().replace(/[^a-z]/g, '-')}`}
              onClick={() => { setOpen(false); item.action?.(); }}
              className="flex items-center gap-3 bg-white shadow-lg rounded-full pl-4 pr-5 py-2.5 hover:shadow-xl transition-shadow whitespace-nowrap"
            >
              <div className={`w-8 h-8 rounded-full ${item.color} flex items-center justify-center flex-shrink-0`}>
                <item.icon className="w-4 h-4" />
              </div>
              <span className="text-sm font-medium text-navy">{item.label}</span>
            </button>
          ))}
        </div>
      )}

      {/* Main FAB */}
      <button
        data-testid="floating-contact-fab"
        onClick={() => setOpen(!open)}
        className={`w-14 h-14 rounded-full shadow-xl flex items-center justify-center transition-all duration-300 ${
          open ? 'bg-gray-700 rotate-0' : 'bg-gold hover:bg-gold-hover animate-pulse-gold'
        }`}
      >
        {open ? (
          <X className="w-6 h-6 text-white" />
        ) : (
          <MessageCircle className="w-6 h-6 text-navy" />
        )}
      </button>
    </div>
  );
};

export default FloatingContactMenu;
